import { render, staticRenderFns } from "./CombinedTable.vue?vue&type=template&id=58040d53&scoped=true"
import script from "./CombinedTable.vue?vue&type=script&lang=js"
export * from "./CombinedTable.vue?vue&type=script&lang=js"
import style0 from "./CombinedTable.vue?vue&type=style&index=0&id=58040d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58040d53",
  null
  
)

/* custom blocks */
import block0 from "./CombinedTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports